import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
const NAV_ITEMS = [{
  label: 'Home',
  to: '/'
}, {
  label: 'Locations',
  to: '/locations'
}, {
  label: 'Services',
  to: '/services'
}, {
  label: 'Book',
  to: '/book'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  React.useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="sticky top-0 z-50 w-full border-b border-white/5 bg-ink-900/95 backdrop-blur" data-id="element-75" data-mp="lfzsea8i3fb">
      <nav aria-label="Main navigation" className="mx-auto flex h-24 w-full max-w-7xl items-center justify-between px-5 sm:px-8" data-id="element-76" data-mp="ehb8jrax5y4z">
        <Link to="/" aria-label="ME time home" className="shrink-0" data-id="element-77" data-mp="1pxrt1z1bz4yp">
          <Logo data-id="element-78" data-mp="1kzgghgjnigcs" />
        </Link>

        <div className="hidden items-center gap-8 lg:flex" data-id="element-79" data-mp="1kyew2lgqwhie">
          {NAV_ITEMS.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => `text-[11px] font-medium uppercase tracking-[0.24em] transition-colors hover:text-lotus-500 ${isActive ? 'text-lotus-500' : 'text-neutral-300'}`} data-id="element-80" data-mp="9nfxwl9tbauh">
              {item.label}
            </NavLink>)}
          <Link to="/book" className="rounded-full bg-lotus-500 px-7 py-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-black transition-colors hover:bg-lotus-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-lotus-400 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-900" data-id="element-81" data-mp="3n19krqgk7lt1">
            Book Now
          </Link>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="rounded-lg p-2 text-neutral-200 transition-colors hover:text-lotus-500 lg:hidden" data-id="element-82" data-mp="34as5ooongoq5">
          {open ? <XIcon className="h-6 w-6" data-id="element-83" data-mp="3b0tdbn5xavxd" /> : <MenuIcon className="h-6 w-6" data-id="element-84" data-mp="3b01johvvz89q" />}
        </button>
      </nav>

      {open && <div id="mobile-menu" className="border-t border-white/5 bg-ink-900 lg:hidden" data-id="element-85" data-mp="3631ahy3qppee">
          <ul className="mx-auto flex w-full max-w-7xl flex-col px-5 py-3 sm:px-8" data-id="element-86" data-mp="2ibm3vt4xklxc">
            {NAV_ITEMS.map(item => <li key={item.to} data-id="element-87" data-mp="2dem768tz0viw">
                <NavLink to={item.to} end={item.to === '/'} className={({
            isActive
          }) => `block py-3 text-base ${isActive ? 'text-lotus-500' : 'text-neutral-200'}`} data-id="element-88" data-mp="2dfoyuiz4b1zv">
                  {item.label}
                </NavLink>
              </li>)}
            <li className="py-3" data-id="element-89" data-mp="2khupv290c0h">
              <Link to="/book" className="block rounded-full bg-lotus-500 px-6 py-3 text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-black" data-id="element-90" data-mp="2nm211b0fnvd">
                Book Now
              </Link>
            </li>
          </ul>
        </div>}
    </header>;
}